//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getAddressList, delAddress, checkAddress,updateAddressByUaId,getDetailsAddress,getLocalCode, getGeoThreeData, getGeoFourData,setDefault} from "@/api/address"
import { getCookie } from "@/utils/auth.js";
import {mapState} from 'vuex';
import { Toast, Dialog,Popup } from 'vant';
import MapLoc from "./mapLoc.vue";
export default {
  data () {
    return {
      addrList: [],//地址列表
      type: "", //来源类型
      uaid: "", //来源地址id
      tblId: "", //运费模版Id
      url: "",
      preParams: {
        uaid: '',
        type: '',
        tblId: '',
        url: ''

      },
      checkUaId : '',
      goodsType:0,//默认0  1  返回有经纬度的地址   0   返回所有地址
      editType:"",//多地址
      addrIdx:'',
      showMap: false,
      addressMsg:"",
      checkIndex: "",
    };
  },

  components: {
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Popup.name]: Popup,
    MapLoc
  },

  computed: {
    ...mapState(['addressObj','goodsInfo'])
  },

  created(){
    if(this.$route.query.type){
      this.preParams.type = this.$route.query.type
    }
    if(this.$route.query.uaid){
      this.preParams.uaid = this.$route.query.uaid
    }
    if(this.$route.query.tblId){
      this.preParams.tblId = this.$route.query.tblId
    }
    if(this.$route.query.url){
      this.preParams.url = this.$route.query.url;
    }
    if(this.$route.query.type){
      this.$store.commit('updateAddress',this.preParams)
    }
    if(this.$route.query.type){
      this.preParams.type = this.$route.query.type
    }

    if(this.$route.query.goodsType){
      this.goodsType = this.$route.query.goodsType
    }
    //多地址类型
    if(this.$route.query.editType){
      this.editType = this.$route.query.editType
    }

    if(this.$route.query.addrIdx){
      this.addrIdx = this.$route.query.addrIdx
    }





    this.getAddressList()
  },

  mounted(){},

  methods: {
    getAddressList(){
      let uid = getCookie("hdu");
      let params = {
        uid: uid,
        type:this.goodsType,//1  返回有经纬度的地址   0   返回所有地址
      }
      getAddressList(params).then(res=> {
        this.addrList = res.data.map((item,index)=> {
          if(this.preParams.uaid == item.uaId){
            // item.isDefault = 1
            this.checkUaId = item.uaId;
            this.checkIndex = index;
          }
          return item
        })
      })
    },
    // 选择地址
    checkAddrIndex(index){
      //如果是个人中心点进来的，地址不可以选择
      if(this.preParams.type == "userCenter"){
        return;
      }
      this.checkIndex = index
    },
    //选择地址
    checkAddress(){
      //如果是个人中心点进来的，地址不可以选择
      // if(this.preParams.type == "userCenter"){
      //   return;
      // }
      if(this.checkIndex ===""){
        Toast('请选择地址');
        return
      }
      // this.addrList.map(item1=> {
      //   item1.isDefault = 0
      // })
      // item.isDefault = 1
      let item = this.addrList[this.checkIndex];

      //是当日达商品，并且地址没有经纬度
      if(this.goodsType == 1 && (item.latitude == null || item.longitude == null)){
        this.openLoaction(item);
      }else{
        this.checkItemFun(item);
      }

    },
    checkItemFun:function(item){
      this.checkUaId = item.uaId
       let uid = getCookie("hdu");
       console.log(this.addressObj,'this.addressObj')
      let params= {
        //  uid: uid,
        type : this.addressObj.type,
        uaid: item.uaId,
        // townId: item.townId,
        tblId: this.addressObj.tblId
      }
      console.log("选择地址-----",params)
      checkAddress(params).then(res=> {
        console.log("返回数据-----",res)
        if(res.code == 200){
          if(this.addressObj.type == 'cart'){
            this.$router.push({
              path: '/shoppingCart',
              query: {
                uaid : item.uaId,
              }
            })
          }else if(this.addressObj.type == 'moreAddrOrder'){
            this.$router.push({
              path: '/MoreAddrOrder',
              query: {
                uaid : item.uaId,
                editType:this.editType,
                addrIdx:this.addrIdx
              }
            })
          }else if(this.addressObj.type == 'goodDetails'){
            this.$store.commit('updateAddress',item)
            console.log(this.addressObj,'this.addressObj')
            this.$router.push({
              path: '/goodDetails',
              query: {
                gid: this.goodsInfo.gid,
                utm_source: this.goodsInfo.utm_source,
                uaid : item.uaId,
              }
            })
            // this.$router.go(-1)
          }else{
            setTimeout(()=> {
              window.location.href = this.addressObj.url + '?uaid=' + item.uaId + '&goodsType=' + this.goodsType
            },500)
          }
        }else{
          Toast('地址不可配送，请重选择地址');
        }
      })
      console.log(this.addressObj)
    },
    //地址新增/编辑
    addNew(item) {
      // console.log(this.preParams,'this.preParams')
      if(item.uaId){
        this.$router.push({
          path: '/newAddress',
          query: {
            source: 'edit',
            uaId: item.uaId,
            goodsType:this.goodsType,
            type:this.preParams.type,
            tblId:this.preParams.tblId,
            url:this.preParams.url
          }
        })
      }else{
        this.$router.push({
          path: '/newAddress',
          query: {
            source: 'add',
            goodsType:this.goodsType,
            type:this.preParams.type,
            tblId:this.preParams.tblId,
            url:this.preParams.url
          }
        })
      }

    },
    //地址删除
    delAddress(item) {
      let params = {
        uaid: item.uaId
      }
      Dialog.confirm({
        title: '提示',
        message: '确认删除该地址？',
        confirmButtonColor	: '#AED000',
        beforeClose
      });
      let that = this
      function beforeClose(action, done) {
        if (action === 'confirm') {
          // setTimeout(done, 1000);
          delAddress(params).then(res=>{
            if(res.code == 200){
              done();
              Toast('删除成功！');
              that.getAddressList()
            }
          })
        } else {
          done();
        }
      }
      // delAddress(params).then(res=>{
      //   if(res.code == 200){
      //     Toast('删除成功！');
      //     this.getAddressList()
      //   }
      // })
    },

    openLoaction(item){
      // 跳转之前要保存已写数据到vuex里面
      this.uaId = item.uaId;
      this.checkItem = item;
      this.showMap = true;
      if(item.provice != item.city){
        this.addressMsg = item.provice + item.city + item.district + item.town + item.addr
      }else{
        this.addressMsg = item.provice + item.district + item.town + item.addr
      }
    },

    getAddressInfo(data){
      console.log(data)
      // this.addr = data.name;
      this.latitude = data.lat;
      this.longitude = data.lng;
      this.saveForm();//保存数据
    },


    //保存地址
    saveForm(){
      let that = this;
      let params = {
        uaId: this.uaId,
        latitude: this.latitude,
        longitude: this.longitude
      }
      console.log("保存数据------",params)
      updateAddressByUaId(params).then(res=> {
        if(res.code == 200){
          that.checkItemFun(that.checkItem);
        }else{
          Toast('网络异常，请稍后再试！')
        }
      })
    },

    //设为默认地址
    setDefaultFn:function(item){
      let that = this;
      let uid = getCookie("hdu");
      let params = {
        uaid: item.uaId,
        uid:uid
      }
      console.log("设为默认------",params)
      setDefault(params).then(res=> {
        if(res.code == 200){
          Toast('设置成功！');
          that.getAddressList()
        }else{
          Toast('网络异常，请稍后再试！')
        }
      })
    }
  },
  filters: {
    formatName(val,num){
      if (val.length == 0 || val == undefined) {
        return;
      }
      if (val.length > num) {
        return val.substring(0, num);
      }
      else {
        return val;
      }
    },
    //手机号位数截取
    substrMobile(mobile,start,end){
      var str = mobile.substring(start,end)
      return str
    }
  }
}




// WEBPACK FOOTER //
// ./src/view/address/addressList.vue